/* import __COLOCATED_TEMPLATE__ from './volume-control-settings-empty.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();